<template>
  <qx-card title="列表">
    <CarDetailDialog ref="carDetailDialog" />
    <LineDetailDialog ref="lineDetailDialog" />
    <section slot="titleRight">
      <qx-permpisions permpisions>
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="orderBO.ajax?cmd=getOrderList"
          :params="fullSearchData"
          bizName="在途跟踪数据导出"
          bizCode="exp100012"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section v-if="scope.column.property === 'orderId'">
                  <span v-if="scope.row.orderType === 1">固定：</span>
                  <span v-else-if="scope.row.orderType === 2">临时：</span>
                  <span v-else>三方：</span>
                  <span class="primary cur" @click="toOrderDetail(scope.row)">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <section
                  v-else-if="scope.column.property === 'sourceRegionName'"
                >
                  <span
                    :class="{
                      primary: scope.row.sourceId !== -1,
                      cur: scope.row.sourceId !== -1,
                    }"
                    @click="toLineDetail(scope.row)"
                    >{{
                      `${scope.row.sourceRegionName.replace(
                        '市',
                        ''
                      )}-${scope.row.desRegionName.replace('市', '')}`
                    }}</span
                  >
                </section>
                <section v-else-if="scope.column.property === 'plateNumber'">
                  <el-popover placement="top" width="120" trigger="hover">
                    <div style="text-align: left">
                      <p>司机：{{ scope.row.carDriverMan }}</p>
                      <p>手机：{{ scope.row.carDriverPhone }}</p>
                      <p>车型：{{ scope.row.vehicleClassName }}</p>
                    </div>
                    <span class="primary cur" slot="reference">{{
                      scope.row[scope.column.property]
                    }}</span>
                  </el-popover>
                </section>
                <section
                  v-else-if="scope.column.property === 'orderLine'"
                  @click="showLineDetail(scope.row)"
                >
                  <span class="primary cur">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <section v-else-if="scope.column.property === 'dependTime'">
                  <span>{{
                    formatDate(scope.row[scope.column.property], 4)
                  }}</span>
                </section>
                <section v-else-if="scope.column.property === 'carDependDate'">
                  <span>{{
                    formatDate(scope.row[scope.column.property], 4)
                  }}</span>
                </section>
                <section v-else-if="scope.column.property === 'carStartDate'">
                  <span>{{
                    formatDate(scope.row[scope.column.property], 4)
                  }}</span>
                </section>
                <section v-else-if="scope.column.property === 'carArriveDate'">
                  <span>{{
                    formatDate(scope.row[scope.column.property], 4)
                  }}</span>
                </section>
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column prop="control" label="操作" width="60" fixed="right">
            <template slot-scope="scope">
              <section>
                <qx-permpisions permpisions>
                  <span class="primary cur" @click="toTrack(scope.row)"
                    >轨迹</span
                  >
                </qx-permpisions>
              </section>
            </template>
          </el-table-column>
          <!-- 操作按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import CarDetailDialog from './carDetailDialog';
import LineDetailDialog from './lineDetailDialog';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  orderList,
} from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    CarDetailDialog,
    LineDetailDialog,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'orderId', label: '订单号码', w: 160, fixed: true },
          { prop: 'customName', label: '客户名称' },
          { prop: 'sourceRegionName', label: '运输线路', w: 120 },
          { prop: 'sourceName', label: '线路名称' },
          { prop: 'plateNumber', label: '车辆信息' },
          { prop: 'vehicleClassName', label: '车辆类型' },
          { prop: 'goodsTypeName', label: '货物类型' },
          { prop: 'dependTime', label: '发车时间' },
          { prop: 'carDependDate', label: '实际发车时间' },
          { prop: 'carStartDate', label: '实际离台时间' },
          { prop: 'carArriveDate', label: '实际到达时间' },
          { prop: 'orderLine', label: '经停信息' },
          { prop: 'orderStateName', label: '订单状态' },
          { prop: 'orgIdName', label: '归属部门' },
          { prop: 'customNumber', label: '客户单号' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: orderList,
    toTrack (item) {
      this.jump({
        label: `轨迹查询-${item.orderId}`,
        url: `/manage/operate/track/trackDetail?orderId=${item.orderId}`,
        full: true,
      });
    },
    toOrderDetail (item) {
      this.jump({
        label: `订单详情-${item.orderId}`,
        url: `/manage/operate/order/deal/orderDetailTab?id=${item.orderId}`,
        full: true,
      });
    },
    toLineDetail (item) {
      if (item.sourceId === -1) {
        return;
      }
      this.jump({
        label: '线路详情',
        url: `/manage/archives/customer/line/detail?id=${item.sourceId}`,
        full: true,
      });
    },
    showCarDetail (item) {
      this.$refs.carDetailDialog.show(item);
    },
    showLineDetail (item) {
      this.$refs.lineDetailDialog.show(item);
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
